import { useEffect, useState } from 'react';

/**
 * Whether this tab is currently on screen.
 *
 * Visibility rather than window focus: a request open in a side-by-side window
 * you aren't typing in has still been seen, and treating that as "away" would
 * badge messages the reader watched arrive.
 */
export function useDocumentVisible(): boolean {
  const [visible, setVisible] = useState(
    () => typeof document === 'undefined' || document.visibilityState === 'visible',
  );

  useEffect(() => {
    const onChange = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onChange);
    onChange();
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);

  return visible;
}
